import { useEffect, useState } from 'react';
import { useAuthenticationContext } from 'contexts';

export const useIdToken = () => {
  const { getIdToken } = useAuthenticationContext();
  const [idToken, setIdToken] = useState<string>('');

  useEffect(() => {
    const setToken = async () => {
      const token = await getIdToken();
      setIdToken(token);
    };

    setToken();
  }, [getIdToken]);

  return idToken;
};
